import React from 'react';
import { Layout } from 'antd';
import TitleBar from './components/TitleBar';
import DataTable from './components/DataTable';
import DetailView, { mainColumns } from './components/DetailView';
import './Jobs.css';
import Clamper from '../../views/ContentWidthClamper';
import HeadlineBreadcrumbList from '../../views/HeadlineBreadcrumbList';
import PageFrame from '../../views/PageFrame';
import ContentHeader from "../../views/ContentHeader";

const { Header, Content, Sider } = Layout;

class JobsView extends React.Component {
  constructor(props) {
    super(props);
    this.setColumns = this.setColumns.bind(this);
    this.setShowDetail = this.setShowDetail.bind(this);
    this.state = {
      columns: mainColumns,
      showDetail: 0,
    };
    this.loadAllJobs = props.loadAllJobs;
  }

  setColumns(columnsData) {
    this.setState({
      columns: columnsData,
    });
  }

  setShowDetail(value) {
    this.setState({
      showDetail: value,
    });
  }

  render() {
    const { jobs, goHome, loading, categories, ephemeralKey, size } = this.props;
    const { columns, showDetail } = this.state;
    let record = 0;
    if (showDetail) {
      record = jobs.filter(obj => obj.id === showDetail);
    }

    return (
        <PageFrame className="debugPageFrame">
          <Clamper>
            <ContentHeader>
              {/* <HeadlineBreadcrumbList>
                {[
                  { onClick: goHome, text: 'Home' },
                  '',
                ]}
              </HeadlineBreadcrumbList> */}
              <TitleBar categories={categories} loadAllJobs2={this.loadAllJobs} bearerToken={ephemeralKey.bearerToken} />
            </ContentHeader>
            <Layout>
              <Content><DataTable jobs={jobs} loading={loading} columns={columns} setShowDetail={this.setShowDetail} setColumns={this.setColumns} pageHeight={size.height} /></Content>
              {showDetail ? (<Sider theme="light" width="320px"><DetailView jobId={this.showDetail} record={record[0]} setShowDetail={this.setShowDetail} setColumns={this.setColumns} /></Sider>) : null}
            </Layout>
          </Clamper>
        </PageFrame>
    );
  }
}

export default JobsView;
